import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CustomerTerms() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 bg-gray-50">

      {/* BACK BUTTON */}
      <button
        onClick={() => navigate("/policies")}
        className="flex items-center gap-2 text-orange-500 font-medium mb-6"
      >
        <ArrowLeft size={18} />
        Back to Policies
      </button>

      {/* TITLE */}
      <h1 className="text-3xl font-bold mb-2">
        Jopo delivery Customer App - Terms & Conditions
      </h1>

      <p className="text-gray-600 mb-6">
        Effective Date: 10/02/2026.
      </p>

      <p className="text-gray-700 mb-6">
        These Terms & Conditions (“Terms”) govern your use of the Jopo Delivery Customer App
        (“the App”), operated by Jopo Delivery “We” By creating an account or using the App,
        you agree to be bound by these Terms.
      </p>

      {/* 1 */}
      <h2 className="text-xl font-bold mt-6">1. About Jopo.</h2>
      <p className="text-gray-700 mt-2">
        Jopo delivery provides a digital platform that connects customers with independent
        delivery partners (“riders”) to facilitate parcel and goods delivery services. Jopo delivery
        does not own delivery vehicles and does not directly perform physical delivery services.
      </p>

      {/* 2 */}
      <h2 className="text-xl font-bold mt-6">2. Eligibility & Account Registration.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>You must be at least 18 years old to use the App.</li>
        <li>You agree to provide accurate and up-to-date information when creating your account.</li>
        <li>You are responsible for keeping your login details secure and for all activities under your account.</li>
      </ul>

      {/* 3 */}
      <h2 className="text-xl font-bold mt-6">3. Services.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>The App allows you to request deliveries, track parcels, communicate with riders, and make payments.</li>
        <li>Delivery times are estimates and may be affected by traffic, weather, location, or operational factors.</li>
        <li>Jopo delivery reserves the right to decline or cancel requests where necessary for safety, legal, or operational reasons.</li>
      </ul>

      {/* 4 */}
      <h2 className="text-xl font-bold mt-6">4. Pricing & Payments.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Delivery fees are displayed before you confirm an order.</li>
        <li>Payments are processed through approved third-party payment providers (e.g., mobile money, cards).</li>
        <li>All charges are non-refundable once a delivery has been completed, except where required by law or where Jopo delivery determines a service failure occurred.</li>
        <li>You are responsible for any additional costs arising from incorrect delivery details provided.</li>
      </ul>

      {/* 5 */}
      <h2 className="text-xl font-bold mt-6">5. User Responsibilities.</h2>
      <p className="text-gray-700 mt-2">You agree to:</p>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Provide accurate pickup and delivery details.</li>
        <li>Ensure parcels are properly packaged and lawful to transport.</li>
        <li>Not request delivery of prohibited, illegal, or dangerous items.</li>
        <li>Treat riders and support staff with respect.</li>
        <li>Use the App only for lawful purposes.</li>
      </ul>

      {/* 6 */}
      <h2 className="text-xl font-bold mt-6">6. Prohibited Items.</h2>
      <p className="text-gray-700 mt-2">You may not use Jopo delivery to transport:</p>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Illegal goods.</li>
        <li>Weapons or hazardous materials until communication is made to the office and approval and all necessary permits are aligned.</li>
        <li>Drugs or controlled substances are not allowed.</li>
        <li>Perishable or fragile items without proper packaging.</li>
        <li>Any item prohibited under Tanzanian law.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        Jopo delivery may refuse service or report unlawful activity to relevant authorities where required.
      </p>

      {/* 7 */}
      <h2 className="text-xl font-bold mt-6">7. Cancellations & Refunds.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>You may cancel a delivery before a rider is assigned without charge.</li>
        <li>If a rider has already been dispatched, a cancellation fee may apply.</li>
        <li>Refunds, where applicable, will be processed in accordance with Jopo’s refund policy and applicable laws.</li>
      </ul>

      {/* 8 */}
      <h2 className="text-xl font-bold mt-6">8. Liability & Limitations.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Jopo delivery acts as a platform connecting customers and riders. We are not liable for delays, losses, or damages caused by factors beyond our control.</li>
        <li>Jopo delivery liability is limited to the value of the delivery fee paid for the specific order, except where prohibited by law.</li>
        <li>Customers are encouraged to declare high-value items and use available insurance options (where offered).</li>
      </ul>

      {/* 9 */}
      <h2 className="text-xl font-bold mt-6">9. Complaints & Support.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Any issues with a delivery should be reported through the App or customer support within a reasonable time.</li>
        <li>Jopo delivery will investigate complaints fairly and work toward a practical resolution.</li>
      </ul>

      {/* 10 */}
      <h2 className="text-xl font-bold mt-6">10. Suspension & Termination.</h2>
      <ul className="list-disc ml-6 text-gray-700 mt-2 space-y-1">
        <li>Violation of these Terms.</li>
        <li>Misuse of the platform.</li>
        <li>Engaging in fraudulent or abusive behaviour.</li>
        <li>Use of the App for unlawful activities.</li>
      </ul>

      <p className="text-gray-700 mt-2">
        You may stop using the App at any time.
      </p>

      {/* 11 */}
      <h2 className="text-xl font-bold mt-6">11. Data Protection & Privacy.</h2>
      <p className="text-gray-700 mt-2">
        Your personal data is handled in accordance with Jopo’s Delivery Privacy & Data Protection Policy
        and the Tanzania Personal Data Protection Act, 2022. By using the App, you consent to such processing.
      </p>

      {/* 12 */}
      <h2 className="text-xl font-bold mt-6">12. Changes to These Terms.</h2>
      <p className="text-gray-700 mt-2">
        We may update these Terms from time to time. Material changes will be communicated through the App or official channels.
        Continued use of the App means you accept the updated Terms.
      </p>

      {/* 13 */}
      <h2 className="text-xl font-bold mt-6">13. Governing Law & Jurisdiction.</h2>
      <p className="text-gray-700 mt-2">
        These Terms are governed by the laws of the United Republic of Tanzania.
        Any disputes arising from use of the App shall be subject to the jurisdiction of Tanzanian courts.
      </p>

      {/* 14 */}
      <h2 className="text-xl font-bold mt-6">14. Contact Information.</h2>
      <div className="text-gray-700 mt-2">
        <p>Jopo delivery Customer Support</p>
        <p>Email: support@jopodelivery.com</p>
        <p>Phone: +255689966875</p>
      </div>
    </div>
  );
}